const quizData = [
  {
    title: "Dive Bomb",
    descriptionHtml:
      "Featuring coffees from <b>Africa and elsewhere</b> that are complex and thrilling in nature. These coffees can be as high-octane as a Peregrine's dive bomb which reach speeds of nearly 250 mph.<br><br>These coffees tend to be<b> fruity and vibrant with pleasant acidity</b>.",
    imageUrl:
      "https://peregrineroasters.myshopify.com/cdn/shop/files/Peregrine-Coffee-Ethiopia-display-opt.jpg?v=1740585690&width=800",
    handle: "africa",
    quizScores: {
      Q1A: 2,
      Q1C: 1,
      Q2B: 1,
      Q3A: 2,
      Q3B: 1,
      Q3D: 1,
      Q4A: 2,
      Q4B: 1,
      Q4C: 1,
      Q4D: 1,
      Q4E: 1,
      Q5A: 2,
      Q5D: 1,
      Q6A: 2,
      Q6B: 1,
      Q6C: 1,
    },
  },
  {
    title: "Dawn Dusk",
    descriptionHtml:
      "Featuring our signature dark roast, <b>Dark Skies</b>, a coffee to be relied upon whether it be dawn or dusk.<br><br>This blend tends to be <b>dark and roasty</b>.",
    imageUrl:
      "https://peregrineroasters.myshopify.com/cdn/shop/files/Peregrine-Coffee-Dark-Skies-display-opt.jpg?v=1740585690&width=800",
    handle: "dark",
    quizScores: {
      Q1C: 1,
      Q2B: 1,
      Q4B: 1,
      Q4C: 1,
      Q4D: 1,
      Q5B: 1,
      Q5C: 2,
      Q6B: 1,
    },
  },
  {
    title: "Glide",
    descriptionHtml:
      "Featuring coffees from <b>the Americas and elsewhere</b> that are balanced and delicious. This subscription is like taking it easy on a smooth glide through the air.<br><br>These coffees tend to be <b>chocolatey &amp; nutty</b>.",
    imageUrl:
      "https://peregrineroasters.myshopify.com/cdn/shop/files/Peregrine-Red-Honey-opt.jpg?v=1740585690&width=800",
    handle: "americas",
    quizScores: {
      Q1A: 2,
      Q1C: 1,
      Q2B: 1,
      Q3A: 1,
      Q3B: 2,
      Q4A: 2,
      Q4B: 2,
      Q4C: 1,
      Q4D: 2,
      Q4E: 2,
      Q5A: 1,
      Q5B: 2,
      Q5D: 1,
      Q6B: 2,
      Q6C: 1,
    },
  },
  {
    title: "The Nest",
    descriptionHtml: `Featuring our house espresso and medium roast, <b>Timberline</b>, the reliable blend that makes Peregrine feel like home. With "The Nest", anywhere can feel like home.<br><br>This blend tends to be filled with notes of <b>caramel, spices, and chocolate</b>.`,
    imageUrl:
      "https://peregrineroasters.myshopify.com/cdn/shop/files/Peregrine-Coffee-Timberline-display.jpg?v=1740585690&width=800",
    handle: "espresso",
    quizScores: {
      Q1A: 2,
      Q1B: 1,
      Q2A: 0,
      Q3A: 1,
      Q3B: 1,
      Q4B: 1,
      Q4C: 1,
      Q4D: 1,
      Q5B: 1,
    },
  },
  {
    title: "Night Flight",
    descriptionHtml:
      "Featuring our <b>current decaf offering</b> for your night flights or just being mindful of your caffeine intake. Can be enjoyed all night long!<br><br>This blend tends to feature <b>mellow notes of caramel and nuts</b>.",
    imageUrl:
      "https://peregrineroasters.myshopify.com/cdn/shop/files/Peregrine-Coffee-Colombia-Decaf-display-opt.jpg?v=1740585690&width=800",
    handle: "decaf",
    quizScores: {
      Q1A: 2,
      Q1C: 2,
      Q2A: 100,
      Q2B: 0,
      Q3A: 2,
      Q3D: 2,
      Q4A: 2,
      Q4D: 2,
      Q4E: 1,
      Q5A: 1,
      Q5B: 1,
      Q5D: 2,
      Q6A: 1,
      Q6B: 1,
    },
  },
  {
    title: "The Hunt",
    descriptionHtml: `Featuring our <i><b>roaster's choice of coffees</b></i> to help you "hunt" for your new favorite. Nothing is more exciting than the pursuit of delicious coffee.<br><br>These coffees <b>vary to stretch your palate but are always delightful</b>.`,
    imageUrl:
      "https://peregrineroasters.myshopify.com/cdn/shop/files/Nicaragua-Norwegian-Yeast-Natural-Coffee_9296e009-950a-438d-8198-ee269bb53dce.jpg?v=1740585690&width=800",
    handle: "roasters-choice",
    quizScores: {
      Q1A: 2,
      Q1C: 1,
      Q2B: 1,
      Q3A: 2,
      Q3D: 2,
      Q4A: 2,
      Q4D: 2,
      Q4E: 1,
      Q5A: 1,
      Q5B: 1,
      Q5D: 2,
      Q6A: 1,
      Q6B: 1,
    },
  },
];

class CoffeeQuiz extends HTMLElement {
  constructor() {
    super();
    this.currentQuestionIndex = 0;
    this.scores = {};
    this.userAnswers = []; // Store user's selections (e.g., "Q1A", "Q2C")
    this.productData = [];
    this.questionMap = this.createQuestionMap(); // Initialize the map
  }

  createQuestionMap() {
    // Define questions once to avoid repetition
    const questions = {
      Q1: "How big of a coffee nerd are you?",
      Q2: "Are you looking for decaf?",
      Q3: "What is your ideal roast level?",
      Q4: "What's your favorite way to make coffee?",
      Q5: "What notes do you prefer in your coffee?",
      Q6: "Do you like coffees from any particular area of the world?",
    };

    // Build the map with references to the questions
    return {
      Q1A: { question: questions.Q1, option: "I'm a coffee expert!", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Expert.png?v=1758769106&width=500" },
      Q1B: { question: questions.Q1, option: "I'm just getting started!", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Novice.png?v=1758768818&width=500" },
      Q1C: { question: questions.Q1, option: "I'm somewhere in between the two!", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Enthusiast.png?v=1758769108&width=500" },
      Q2A: { question: questions.Q2, option: "Decaf", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Decaf.png?v=1758768818&width=500" },
      Q2B: { question: questions.Q2, option: "Regular", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Regular.png?v=1758768818&width=500" },
      Q3A: { question: questions.Q3, option: "Light", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Light.png?v=1758768818&width=500" },
      Q3B: { question: questions.Q3, option: "Medium", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Medium_0f65028a-b9ef-43f3-8693-bd7206f4aeec.png?v=1758768930&width=500" },
      Q3C: { question: questions.Q3, option: "Dark", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Dark.png?v=1758768818&width=500" },
      Q3D: { question: questions.Q3, option: "I'm not sure!", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Im_Not_Sure.png?v=1758768930&width=500" },
      Q4A: { question: questions.Q4, option: "Pour Over", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Pour_Over.png?v=1758768818&width=500" },
      Q4B: { question: questions.Q4, option: "French Press", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_French_Press.png?v=1758768930&width=500" },
      Q4C: { question: questions.Q4, option: "Espresso", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Espresso.png?v=1758768930&width=500" },
      Q4D: { question: questions.Q4, option: "Drip", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Drip.png?v=1758768930&width=500" },
      Q4E: { question: questions.Q4, option: "Cold Brew", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Cold_Brew.png?v=1758768930&width=500" },
      Q5A: { question: questions.Q5, option: "Fruity, Floral, and Complex", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Fruity_-_Floral_-_Complex.png?v=1758768818&width=500" },
      Q5B: { question: questions.Q5, option: "Chocolatey and Nutty", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Chocolatey_Nutty.png?v=1758768818&width=500" },
      Q5C: { question: questions.Q5, option: "Roasty and Traditional", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Roasty_-_Traditional.png?v=1758768818&width=500" },
      Q5D: { question: questions.Q5, option: "Give me a mix!", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Mix_it_Up.png?v=1758768818&width=500" },
      Q6A: { question: questions.Q6, option: "Africa", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Africa.png?v=1758768929&width=500" },
      Q6B: { question: questions.Q6, option: "The Americas", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Americas.png?v=1758768817&width=500" },
      Q6C: { question: questions.Q6, option: "I want to explore!", imageUrl: "https://cdn.shopify.com/s/files/1/0624/6904/6374/files/Quiz_-_Explore.png?v=1758768930&width=500" },
    };
  }

  connectedCallback() {
    this.fetchProductData();
    this.initializeScores();

    setTimeout(() => {
      this.renderQuestions();
    }, 100);
  }

  fetchProductData() {
    this.productData = quizData; // Use the quizData directly
  }

  initializeScores() {
    this.scores = {}; // Reset scores
    this.productData.forEach((product) => {
      this.scores[product.handle] = 0; // Initialize score for each product
    });
  }

  getQuestions() {
    // Extract unique questions from the questionMap
    const questions = [];
    const addedQuestions = new Set(); // Keep track of questions already added

    for (const key in this.questionMap) {
      const { question } = this.questionMap[key];
      if (!addedQuestions.has(question)) {
        questions.push(question);
        addedQuestions.add(question);
      }
    }
    return questions;
  }

  renderQuestions() {
    const questions = this.getQuestions();
    const questionContainer = this.querySelector(".question-container");

    if (!questionContainer) return; // Check if the container exists

    // Generate HTML for all questions and their options using semantic form elements
    const questionsHTML = questions
      .map((questionText, index) => {
        const options = this.getOptionsForQuestion(questionText);
        const optionsHTML = options
          .map((optionKey) => {
            const { option, imageUrl } = this.questionMap[optionKey];
            return `
              <label class="card card media-card media-card--quiz flex flex-col leading-none relative cursor-pointer">
                <input type="radio" name="question-${index}" class="sr-only" data-option-key="${optionKey}" data-question-index="${index}">
                <div class="card-inner">
                  <div class="media no-bg media-quiz relative overflow-hidden">
                    <div class="media-wrapper">
                      ${imageUrl
                ? `<img src="${imageUrl}" alt="${option}">`
                : `<div class="product-card__placeholder-image"><span></span></div>`
              }
                    </div>
                  </div>
                  <div class="animate media-card__details">${option}</div>
                </div>
              </label>
            `;
          })
          .join("");

        return `
          <fieldset class="question-block">
            <animate-element class="block" data-animate="fade-up" data-animate-delay="100">
              <legend class="question-text heading title-sm">${questionText}</legend>
            </animate-element>
            <motion-list class="answer-options product-grid card-grid card-grid--3 mobile:card-grid--2 grid">${optionsHTML}</motion-list>
          </fieldset>
        `;
      })
      .join("");

    questionContainer.innerHTML = questionsHTML;

    // Add event listeners to the radio inputs
    questionContainer.querySelectorAll("input[type='radio']").forEach((radio) => {
      radio.addEventListener("change", this.handleAnswerChange.bind(this));
    });
  }

  handleAnswerChange(event) {
    const selectedOptionKey = event.target.dataset.optionKey;
    const questionIndex = event.target.dataset.questionIndex;

    // Update visual styles (the parent label gets styled)
    const questionBlock = this.querySelectorAll(".question-block")[questionIndex];
    questionBlock.querySelectorAll(".card").forEach((card) => {
      card.classList.remove("selected");
    });
    const selectedCard = event.target.closest(".card");
    selectedCard.classList.add("selected");

    // Subtle pop animation using Motion.js
    if (window.Motion) {
      window.Motion.animate(
        selectedCard,
        { scale: [1, 1.05, 1] },
        { duration: 0.35, easing: [0.22, 1, 0.36, 1] }
      );
    }

    this.userAnswers[questionIndex] = selectedOptionKey; // Store the coded key
    this.recalculateScores();

    // Check if all questions are answered
    const answeredQuestionCount = this.userAnswers.filter((answer) => answer).length;
    const totalQuestions = this.getQuestions().length;
    if (answeredQuestionCount === totalQuestions) {
      this.showResult();
    }
  }

  getOptionsForQuestion(question) {
    // Get all option keys (Q1A, Q2B, etc.) for a given question.
    const options = [];
    for (const key in this.questionMap) {
      if (this.questionMap[key].question === question) {
        options.push(key);
      }
    }
    return options;
  }

  handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.handleAnswerClick(event);
    }
  }

  handleAnswerClick(event) {
    const selectedOptionKey = event.currentTarget.dataset.optionKey;
    const questionIndex = event.currentTarget.dataset.questionIndex;

    // Highlight the selected option
    const questionBlock = this.querySelectorAll(".question-block")[questionIndex];
    questionBlock.querySelectorAll(".card").forEach((card) => {
      card.classList.remove("selected");
    });
    const selectedCard = event.currentTarget;
    selectedCard.classList.add("selected");

    // Subtle pop animation using Motion.js
    if (window.Motion) {
      window.Motion.animate(
        selectedCard,
        { scale: [1, 1.05, 1] },
        { duration: 0.35, easing: [0.22, 1, 0.36, 1] }
      );
    }

    this.userAnswers[questionIndex] = selectedOptionKey; // Store the coded key
    this.recalculateScores();

    // Check if all questions are answered
    const answeredQuestionCount = this.userAnswers.filter((answer) => answer).length;
    if (answeredQuestionCount === this.getQuestions().length) {
      this.showResult();
    }
  }

  recalculateScores() {
    // Reset all scores to zero
    this.initializeScores();

    // Sum scores for every answered question from scratch
    this.userAnswers.forEach((answerKey) => {
      if (!answerKey) return;
      this.productData.forEach((product) => {
        const score = product.quizScores[answerKey];
        if (score != null) {
          this.scores[product.handle] += score;
        }
      });
    });
  }

  showResult() {
    const resultContainer = this.querySelector(".result-container");

    // Determine the winning product
    const bestMatch = Object.keys(this.scores).reduce((a, b) =>
      this.scores[a] > this.scores[b] ? a : b
    );

    // Find the full product data for the best match
    const matchingProduct = this.productData.find((product) => product.handle === bestMatch);

    if (!matchingProduct) return;

    // console.log({ matchingProduct });

    // Build a visually appealing result section
    const resultHTML = `
      <div class="result-inner">
        <animate-element class="block" data-animate="fade-up" data-animate-delay="100">
          <h2 class="result-heading heading title-md">Your Perfect Coffee Subscription</h2>
        </animate-element>
        
        <div class="result-content">
          <div class="result-image-container">
            <animate-element class="block" data-animate="fade-up" data-animate-delay="200">
              <img src="${matchingProduct.imageUrl}" alt="${matchingProduct.title}" class="result-image">
            </animate-element>
          </div>
          
          <div class="result-details">
            <animate-element class="block" data-animate="fade-up" data-animate-delay="300">
              <h3 class="result-title heading title-sm">${matchingProduct.title}</h3>
              <div class="result-description">${matchingProduct.descriptionHtml}</div>
              
              <div class="result-actions">
                <a class="button button--primary button--sm icon-with-text" href="/products/${matchingProduct.handle}" is="hover-link">
                  <span class="btn-fill" data-fill></span>
                  <span class="btn-text">
                    View This Subscription
                  </span>
                </a>
                <a class="button button--secondary button--sm icon-with-text" href="/collections/subscription" is="hover-link">
                  <span class="btn-fill" data-fill></span>
                  <span class="btn-text">
                    Browse All Subscriptions
                  </span>
                </a>
              </div>
            </animate-element>
          </div>
        </div>
      </div>
    `;

    resultContainer.innerHTML = resultHTML;
    resultContainer.style.display = "block";

    // Add debug panel if debug attribute is present
    if (this.hasAttribute("debug")) {
      this.renderDebugPanel(resultContainer);
    }

    // Scroll to the result container
    // resultContainer.scrollIntoView({ behavior: "smooth" });
  }

  renderDebugPanel(container) {
    // Remove any existing debug panel
    const existingDebug = container.querySelector(".debug-panel");
    if (existingDebug) {
      existingDebug.remove();
    }

    // Sort products by score (highest first)
    const sortedProducts = Object.keys(this.scores).sort((a, b) => this.scores[b] - this.scores[a]);

    // Generate HTML for user answers
    const answersHTML = this.userAnswers
      .map((answer, index) => {
        if (!answer) return "";
        const question = this.questionMap[answer].question;
        const option = this.questionMap[answer].option;
        return `<li>${question}: <div>${option}</div></li>`;
      })
      .filter((item) => item !== "")
      .join("");

    // Generate HTML for product scores
    const scoresHTML = sortedProducts
      .map((product) => {
        // Find the full product data to display title instead of handle
        const productData = this.productData.find((p) => p.handle === product);
        const productName = productData ? productData.title : product;
        return `
          <div class="debug-score-item">
            <div class="debug-product-name">${productName}</div>
            <div class="debug-product-score">${this.scores[product]}</div>
          </div>
        `;
      })
      .join("");

    // Build the complete debug panel HTML
    const debugHTML = `
      <div class="debug-panel">
        <h3 class="debug-heading">Debug: Product Scores</h3>
        
        <div class="debug-score-list">
          <div class="debug-score-header">
            <div class="debug-product-name">Product</div>
            <div class="debug-product-score">Score</div>
          </div>
          ${scoresHTML}
        </div>
        
        <h4 class="debug-subheading">User Answers:</h4>
        <ul class="debug-answers-list">
          ${answersHTML}
        </ul>
      </div>
    `;

    // Append the debug panel to the container
    container.insertAdjacentHTML("beforeend", debugHTML);
  }
}

customElements.define("coffee-quiz", CoffeeQuiz);
